import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const tokenRetrievalPlugin = createPlugin({
  id: 'token-retrieval',
  routes: {
    root: rootRouteRef,
  },
});

export const TokenRetrievalPage = tokenRetrievalPlugin.provide(
  createRoutableExtension({
    name: 'TokenRetrievalPage',
    component: () =>
      import('./components/TokenRetrievalPage').then(m => m.TokenRetrievalPage),
    mountPoint: rootRouteRef,
  }),
);
